import classNames from 'classnames/bind'

import {sendClickNlog} from '$utils/nlog'

import Styles from './InsuranceDetailButton.module.scss'

import type {MouseEvent, ReactNode} from 'react'

const cx = classNames.bind(Styles)

interface InsuranceDetailButtonProps {
    text: ReactNode
    onClick?: (e: MouseEvent<HTMLButtonElement>) => void
    nClkCode?: string
    inViewRef?: (node?: Element | null | undefined) => void
}

const InsuranceDetailButton = ({text, onClick, nClkCode, inViewRef}: InsuranceDetailButtonProps) => {
    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
        nClkCode && sendClickNlog(nClkCode)
        onClick && onClick(e)
    }
    return (
        <button ref={inViewRef} type="button" className={cx('article')} onClick={handleClick}>
            <span className={cx('inner')}>{text}</span>
        </button>
    )
}

export default InsuranceDetailButton
